import { Provider } from '@shopify/app-bridge-react';
import { AppProvider } from '@shopify/polaris';
import Orders from './orders';
import ShowLocation from './locations/Show';
import ChargeCustomer from './customers/Charge';
import DiscountCodes from './discount-codes';
import Customers from './customers';

import translations from '@shopify/polaris/locales/en.json';

import {BrowserRouter as Router, Switch, Route, Redirect} from 'react-router-dom';
import ChargeCustomerForOrder from "./customers/ChargeOrder";
import SendQuote from "./send-quote/index";
import {ShowUser, Users} from "./users";
import {ApiUsers, CreateApiUser, ShowApiUser} from "./api-users";
import ScheduleList from "./products/ScheduleList";
import OrdersList from "./orders/List";
import CustomerOrders from "./customers/Orders";
import InventoryPanel from "./inventory/Panel";

const Main = (props) => {
    return (
        <Provider config={props.config}>
            <AppProvider i18n={translations}>
                <Router>
                    <Switch>
                        <Redirect path="/home" to="/orders" />
                        <Route path="/discount-codes"><DiscountCodes /></Route>
                        <Route path="/charge/order"><ChargeCustomerForOrder /></Route>
                        <Route path="/charge"><ChargeCustomer /></Route>
                        <Route path="/orders/:customerId"><Orders /></Route>
                        <Route path="/customers/:customerId/orders"><CustomerOrders /></Route>
                        <Route path="/customers"><Customers /></Route>
                        <Route path="/locations/:locationId"><ShowLocation /></Route>
                        <Route path="/send-quote"><SendQuote /></Route>

                        <Route path="/users/:userId"><ShowUser /></Route>
                        <Route path="/users"><Users /></Route>

                        <Route path="/orders"><OrdersList /></Route>

                        <Route path="/products/schedule"><ScheduleList /></Route>

                        <Route path="/inventory"><InventoryPanel /></Route>

                        <Route path="/api-users/new"><CreateApiUser /></Route>
                        <Route path="/api-users/show/:userId"><ShowApiUser /></Route>
                        <Route path="/api-users"><ApiUsers /></Route>
                    </Switch>
                </Router>
            </AppProvider>
        </Provider>

    );
}


export default Main;
